import type { OpenPixCustomer } from '../openPixState.tsx';
import { store } from '../OpenPixStore.tsx';

/**
 * $openpix.push([
 *   'customer',
 *   {
 *     name,
 *     email,
 *     taxID,
 *     phone,
 *   }
 *  ])
 */
export const setCustomer = (customer: OpenPixCustomer) => {
  store.setState({
    customer,
    isTemp: false,
  });
};
